import { UserSearchParamDTO } from "./UserSearchParamDTO";

export class AddUserModel {
    constructor() {
        this.PermissionSets = new Array<number>();
        this.LangKey = ""
        this.SendActivationMail = true;
        this.Filters=new UserSearchParamDTO();
        this.KeyMap={}

    }
    ID:number=0
    Username: string=""
    NameEN: string=""
    NameAR: string=""
    LangKey: string=""
    PermissionSets: number[]=[]
    TemplateID?: number=null
    TemplateSysName: string=""
    OrganizationID: number=1
    SendActivationMail: boolean=false
    ActivationPageURL: string=""
    DepartmentID?: number=null
    SamAccount: string=""
    Email: string=""
    IsAnonymous: boolean=false
    KeyMap: Record<string, string>={}
    Token: string=""
    EmailProviderName: string=""
    SMSProviderName: string=""
    ExtraParams: number=0
    ValidationError: string=""
    PhoneInputMobile: string=""
    Filters:UserSearchParamDTO=new UserSearchParamDTO();

}